'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

var React = require('react');
var index = require('../../../../node_modules/classnames/index.js');
var Tools = require('./Tools/Tools.js');
var Insurance = require('./Insurance/Insurance.js');
var Account = require('./Account/Account.js');
var Explore = require('./Explore/Explore.js');
require('./FooterNavigation.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var FooterNavigation = function (props) {
    var _a = React.useState(0), activeId = _a[0], setActiveId = _a[1];
    var menuItems = props.menuItems, accountProps = props.accountProps, insuranceLinks = props.insuranceLinks, toolsProps = props.toolsProps, exploreProps = props.exploreProps, NextLink = props.NextLink;
    var loadContentComponent = function (id) {
        switch (id) {
            case 1:
                return React__default['default'].createElement(Explore.Explore, { NextLink: NextLink, gtmClassName: exploreProps.gtmClassName, category: exploreProps.category, relatedPosts: exploreProps.relatedPosts, onBtnClick: function () { return setActiveId(0); } });
            case 2:
                return React__default['default'].createElement(Tools.Tools, { NextLink: NextLink, title: toolsProps.title, subtitle: toolsProps.subtitle, gtmClassName: toolsProps.gtmClassName, calculatorArticles: toolsProps.calculatorArticles, onBtnClick: function () { return setActiveId(0); } });
            case 3:
                return React__default['default'].createElement(Insurance.Insurance, { NextLink: NextLink, onBtnClick: function () { return setActiveId(0); }, insuranceLinks: insuranceLinks });
            case 4:
                return React__default['default'].createElement(Account.Account, { NextLink: NextLink, title: accountProps.title, subtitle: accountProps.subtitle, imgSrc: accountProps.imgSrc, onBtnClick: function () { return setActiveId(0); } });
        }
    };
    return (React__default['default'].createElement("div", { className: activeId > 0 ? 'footerNavigation__modal' : '' },
        React__default['default'].createElement("div", { className: "footerNavigation" },
            React__default['default'].createElement("div", { className: 'footerNavigation__content' },
                React__default['default'].createElement("button", { className: "footerNavigation__closeBtn " + (activeId > 0 ? "footerNavigation__closeBtn--active" : ""), onClick: function () { return setActiveId(0); } }, "\u00D7"),
                React__default['default'].createElement("div", null, loadContentComponent(activeId))),
            React__default['default'].createElement("div", { className: "footerNavigation__menus" }, menuItems && menuItems.map(function (item) {
                return React__default['default'].createElement("button", { key: item.id, className: index['default']("footerNavigation__menus__openBtn", item.id === activeId ? 'footerNavigation__menus__openBtn--active' : "", item.gtmClassName), onClick: function () { return (activeId === item.id ? setActiveId(0) : setActiveId(item.id)); } },
                    React__default['default'].createElement("i", { className: "footerNav-icon footerNav-icon--" + item.icon + (item.id === activeId ? "--active" : "") }),
                    React__default['default'].createElement("span", null, item.text));
            })))));
};

module.exports = FooterNavigation;
//# sourceMappingURL=FooterNavigation.js.map
